import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { t as translate } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => localStorage.getItem("t2s_lang") || "en");

  const t = useCallback((key) => translate(key, language), [language]);

  useEffect(() => {
    localStorage.setItem("t2s_lang", language);
    document.documentElement.lang = language;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
